import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogViewPageRoutingModule } from './blog-view-routing.module';
import { BlogViewPage } from './blog-view.component';
import { BackboneComponent } from '@components/backbone/backbone.component';
import { HeaderPageTitleBoxComponent } from '@components/headers/page-title-box/page-title-box.component';
import { PlaceholderCardFormVerticalComponent } from '@components/placeholders/card-form-vertical/card-form-vertical.component';
import { ButtonModule } from 'primeng/button';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ChipsModule } from 'primeng/chips';
import { EditorModule } from 'primeng/editor';
import { RouterModule } from '@angular/router';
import { ShowForPermissionsDirective } from '@directives/show-for-permissions.directive';

@NgModule({
  declarations: [
    BlogViewPage
  ],
  imports: [
    CommonModule,
    BlogViewPageRoutingModule,
    BackboneComponent,
    HeaderPageTitleBoxComponent,
    PlaceholderCardFormVerticalComponent,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    ChipsModule,
    EditorModule,
    RouterModule,
    ShowForPermissionsDirective
  ]
})
export class BlogViewPageModule { }
